import { render } from "./CreateAppointmentPassForm.vue?vue&type=template&id=e27480da"
import script from "./CreateAppointmentPassForm.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentPassForm.vue?vue&type=script&lang=js"

import "./CreateAppointmentPassForm.vue?vue&type=style&index=0&id=e27480da&scope=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__